export default __webpack_public_path__ + "static/media/ac_dd3.ae4597f1.bmp";